<script>
import { getCurrentInstance, h } from 'vue'
export default {
  name: 'JSteps',
  props: {
    active: {
      type: Number,
      default: 1
    }
  },
  render () {
    const { ctx } = getCurrentInstance()
    const items = ctx.$slots.default()
    const dynamicItems = []
    items.forEach(item => {
      if (item.type.name === 'JStepsItem') {
        dynamicItems.push(item)
      } else {
        item.children.forEach(c => {
          dynamicItems.push(c)
        })
      }
    })
    const itemsJsx = dynamicItems.map((item, i) => {
      const currentClass = i < this.active ? 'j-steps-item active' : 'j-steps-item'
      const currentDesc = i < this.active ? item.props.desc : ''
      return h('div', { class: currentClass }, [
        h('div', { class: 'step' }, [
          h('span', String(i + 1))
        ]),
        h('div', { class: 'title' }, item.props.title),
        h('div', { class: 'desc' }, currentDesc)
      ])
    })
    return h('div', { class: 'j-steps' }, itemsJsx)
  }
}
</script>
<style lang="less">
.j-steps {
  display: flex;
  text-align: center;
  &-item {
    flex: 1;
    &:first-child {
      .step {
        &::before {
          display: none;
        }
      }
    }
    &:last-child {
      .step {
        &::after {
          display: none;
        }
      }
    }
    &.active {
      .step {
        > span {
          border-color: @themeColor;
          background: @themeColor;
          color: #fff
        }
        &::before,&::after {
          background: @themeColor;
        }
      }
      .title {
        color: @themeColor;
      }
    }
    .step {
      position: relative;
      > span {
        width: 48px;
        height: 48px;
        font-size: 28px;
        border: 2px solid #e4e4e4;
        background: #fff;
        border-radius: 50%;
        line-height: 44px;
        color: #ccc;
        display: inline-block;
        position: relative;
        z-index: 1;
      }
      &::after,&::before{
        content: "";
        position: absolute;
        top: 23px;
        width: 50%;
        height: 2px;
        background: #e4e4e4;
      }
      &::before {
         left: 0;
      }
      &::after {
         right: 0;
       }
    }
    .title {
      color: #999;
      padding-top: 12px;
    }
    .desc {
      font-size: 12px;
      color: #999;
      padding-top: 6px;
    }
  }
}
</style>
